<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { useVModel } from '@vueuse/core';
import { cn } from '../lib/utils';
import { useFormField } from '../form/useFormField';

const props = defineProps<{
  defaultValue?: string | number
  modelValue?: string | number
  class?: HTMLAttributes['class']
  autocomplete?: string
}>();

// eslint-disable-next-line func-call-spacing
const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number): void
}>();

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue,
});

const { error } = useFormField();
</script>

<template>
  <input
    v-model="modelValue"
    :class="
      cn(
        `
      inline-flex h-[40px] w-full border bg-[color:var(--theme-background-color)] px-[12px] py-[8px] text-sm
      outline-none focus:border-[color:var(--input-active-border)]
      disabled:cursor-not-allowed disabled:opacity-50 border-[color:var(--input-primary-border)]
      text-[color:var(--theme-heading-color)]`,
        error && 'border-[color:var(--input-error-border)]',
        props.class ?? ''
      )
    "
    :autocomplete="props.autocomplete || 'off'"
  >
</template>
